// CSS styles
import 'ol/ol.css'; // does not work anymore
import '../css/list.css';
import '../css/loader.css';
import '../css/main.css';
import '../css/notify.css';
import '../css/table.css';
import '../css/user.css';
import '../css/wizard.css';
import '../css/wms.css';

// Modules
import { getCenter } from 'ol/extent';
import { transformExtent } from 'ol/proj';
import { View } from 'ol';

import { filterDatalist, load as loadCodes, retrieveCode } from './formal';
import { basemapPromise, getWFS, getWMS } from './map/layers';
import { assignPlanCategoryToLastDrawing, drawInitialization } from './map/draw';
import { getLayerById, visibleComputationArea } from './map/layer-tools';
import { createPopup } from './map/popup';
import {
  getLegendUrl, map, getListSelectedFeatures
} from './map/tools';
import { authenticationCheck } from './request/authentication';
import { getEmissions, sendFeaturesToBackend } from './request/computation';
import { saveGeometryToFile } from './save';
import {
  activateClickInteractions as activateTableClickInteractions,
  addSummaryToTable, compareTables, removeColumn
} from './table';
import * as notification from './notify';
import { stampEnvironment } from './util';
import * as wizard from './wizard';

// Script
stampEnvironment();

basemapPromise().then(baseMapLayers => {
  const bm = baseMapLayers.graatoner[33];
  map.getLayers().insertAt(0, bm);
  const nib = baseMapLayers.flybilder[33];
  nib.setVisible(false);
  map.getLayers().insertAt(1, nib);

  const p = bm.getSource().getProjection();
  const e = p.getExtent();

  const ec4258 = [-22, 48, 46, 75]; // degrees
  const extentConstraint = transformExtent(ec4258, 'EPSG:4258', p.getCode());

  map.setView(new View({
    center: getCenter(e),
    extent: extentConstraint,
    projection: p,
    zoom: 2.8,
    maxZoom: 17,
    minZoom: 2
  }))
});

// Grunnkart WMS:
map.addLayer(getWMS('grunnkart'));
// Other WMSes:
[
  'ar5', 'skogbonitet', 'gnr', 'eiendom',
  'kp', 'kpf', 'kpp', 'kdp', 'kdpf', 'kdpp', 'rp', 'rpf', 'rpp', 'tønsberg'
].forEach(p => {
  const wms = (p === 'tønsberg') ? getWFS(p) : getWMS(p);
  map.addLayer(wms);
  // getLayerById(p).setVisible(false);
  wms.setVisible(false);
});

// Add WMS's legend:
document.getElementById('ar5LegendImg').src = getLegendUrl('ar5', 'arealtype');
document.getElementById('abLegendImg').src = getLegendUrl('grunnkart', 'arealbruk');
document.getElementById('tsLegendImg').src = getLegendUrl('grunnkart', 'treslag');
document.getElementById('sbLegendImg').src = getLegendUrl('grunnkart', 'skogbonitet');
document.getElementById('oLegendImg').src = getLegendUrl('grunnkart', 'organisk');
document.getElementById('bLegendImg').src = getLegendUrl('grunnkart', 'bebygd');
document.getElementById('klLegendImg').src = getLegendUrl('grunnkart', 'kraftlinje');
document.getElementById('rppLegendImg').src = getLegendUrl('rpp', 'Planomrade_vn2');
document.getElementById('authorizedLegendImg').src = getLegendUrl('authorized', 'autorisert_planomrade');

authenticationCheck(true);

drawInitialization(map);

notification.initialize();
wizard.initialize();

createPopup();

loadCodes();

document.getElementById('confirmPlanBtn').onclick = () => {
  // const input = document.getElementById('formål');
  if (retrieveCode()) formål.setCustomValidity('');
  else formål.setCustomValidity('Angi en verdi fra lista');
  const validForm = document.getElementById('selection').checkValidity();
  if (validForm) wizard.moveTo('home');
};

const results = document.getElementById('resultsContent');

const loadingExtraTables = (b) => {
  const togglers = ['toggleComparedEmissions', 'toggleCurrentEmissions'];
  if (b) togglers.map(t => document.getElementById(t).classList.add('loading'));
  else togglers.map(t => document.getElementById(t).classList.remove('loading'));
};

activateTableClickInteractions();

const queryBtn = document.getElementById('queryBtn');
const token = { cancel: () => console.log('Avbryter') };
queryBtn.onclick = () => {
  if (queryBtn.classList.contains('loading')) {
    token.cancel();
    return;
  }
  if (!document.getElementById('wizard').classList.contains('logged-in')) {
    notification.warn('Krever pålogging');
    return;
  }

  const filteredFeatures = getListSelectedFeatures();

  if (filteredFeatures.length > 0) {
    queryBtn.classList.add('loading');
    // queryBtn.disabled = true;
    sendFeaturesToBackend(filteredFeatures).then(id => {
      getEmissions(id, token).then(promised => {
        promised.id = 'plannedEmissions';
        addSummaryToTable(promised);
        results.querySelector('#plannedEmissions').replaceWith(promised);
        wizard.moveTo('results');
        visibleComputationArea(id);
        // Prepare query for current emissions:
        loadingExtraTables(true);
        filteredFeatures.forEach(f => {
          if (f.get('plankategori') !== 'Nåværende')
            f.set('plankategori', 'Nåværende');
        });
        getEmissions(id, token, 'today').then(table => {
          table.id = 'currentEmissions';
          removeColumn(table, 'Arealbruk plan');
          addSummaryToTable(table);
          results.querySelector('#currentEmissions').replaceWith(table);
          // Prepare comparison between current and planned emissions:
          compareTables(table, promised);
        }).catch(e => { console.log(e); notification.warn(e.statusText); })
        .finally(f => loadingExtraTables(false));
        }).catch(e => { console.log(e); notification.warn(e.statusText); })
      .finally(f => {
        queryBtn.classList.remove('loading');
        // queryBtn.disabled = false;
      });
    }).catch(e => { console.log(e); notification.warn(e.statusText); });
  }
};

document.getElementById('saveGeometryBtn').onclick = () => saveGeometryToFile();

const currentRadio = document.getElementById('currentRadio');
const kommuneRadio = document.getElementById('kommuneRadio');
const reguleringsRadio = document.getElementById('reguleringsRadio');
const formålChoiceGroup = document.getElementById('formålChoiceGroup');
const formål = document.getElementById('formål');
const ua = navigator.userAgent;
const epiphany = ua.includes('AppleWebKit') && ua.includes('Version');
const v = `${epiphany ? '[1001] ' : ''}Bebyggelse og anlegg`;
formål.value = v; // to be able to proceed when Nåværende is default choice
const visibleFormålChoice = (visible) => {
  formålChoiceGroup.hidden = !visible;
  formål.value = visible ? '' : v; // need something to validate form
};
const planCategoryChosen = (radio) => {
  assignPlanCategoryToLastDrawing(radio.value);
  filterDatalist(radio.value);
  visibleFormålChoice((radio.id === 'currentRadio') ? false : true);
};
currentRadio.onchange = (e) => planCategoryChosen(e.target);
kommuneRadio.onchange = (e) => planCategoryChosen(e.target);
reguleringsRadio.onchange = (e) => planCategoryChosen(e.target);
